/* eslint-disable max-len */
/* eslint-disable camelcase */
import { API } from '@/redux/config';
import { toast } from 'react-toastify';
import { useSiteId } from '../../utils/hooks/useCustomerId';
import { getLocalStorageData } from '../../utils/LocalStorage';
import { StnAPI } from '../config/customHeadersApi';
import { raiseErrorException } from '../../utils/raiseErrorException';
import {
	getStnActiveEngineerUsers,
	getStnEngineerUsers,
	setAddCmdbServices,
	setAddVmQuota,
	setAlertService,
	setAllCustomers,
	setAllCustomersReadAll,
	setArchivedCustomers,
	setCmdbServices,
	setCurrentCustomer,
	setCurrentCustomerOnboardingData,
	setDeletedCustomer,
	setNewCustomer,
	setReducerError,
	setRemainingQuota,
	setSsoConfigSettings,
	setToggleEmailRecipientsModal,
	setToggleModal,
	setToggleSAMLSettingsModal,
	setUpdateAlertServices,
	setUpdateCmdbServices,
	setUpdateVmQuota,
	setVmQuota,
	start,
} from '../reducers/customerReducer';
import { getUserProvisioning } from './alertingToolsActions';
import { UpdateCredsAction } from './authActions';
import { syncSharepointMetadata } from './graphapiActions';
import { getEscalationPath } from './onboardingActions';

// Get all Customers
export const getAllCustomers = () => async dispatch => {
	try {
		dispatch(start());
		let response = await API.get('/customers');
		dispatch(setAllCustomers(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};

export const getAllCustomersReadAll = () => async dispatch => {
	try {
		dispatch(start());
		let response = await API.get('/customers/all');

		dispatch(setAllCustomersReadAll(response?.data));
	} catch (err) {
		if (err?.response?.status === 403) {
			try {
				const response = await API.get('/customers');
				dispatch(setAllCustomersReadAll(response?.data));
			} catch (secondErr) {
				raiseErrorException(secondErr, dispatch, setReducerError, 'get');
			}
		} else {
			raiseErrorException(err, dispatch, setReducerError, 'get');
		}
	}
};

// Get archived Customers
export const getArchivedCustomers = () => async dispatch => {
	try {
		dispatch(start());
		const response = await API.get('/customers/archived');

		dispatch(setArchivedCustomers(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};

// View A Single Customer-- updates customer (logged-in user's customer) in state
export const getCurrentCustomer = () => async dispatch => {
	try {
		dispatch(start());
		// const response = await API.get(`/customers/${customerID}`)
		const response = await API.get(`/customers/view`);

		dispatch(setCurrentCustomer(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};

// Set Customer By ID -- updates currentCustomer (selected customer from dropdown/table) in state
export const getCustomerBySelectedID = customerID => async dispatch => {
	// export const setCustomerByID = customerID => async dispatch => {
	try {
		dispatch(start());
		const response = await StnAPI.get(`/customers/view`, {
			headers: {
				'x-customer-id': customerID,
				'x-site-id': useSiteId(),
			},
		});

		dispatch(setCurrentCustomer(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};
// Set Customer By ID -- updates currentCustomer (selected customer from dropdown/table) in state
export const getStnEngineer = customerID => async dispatch => {
	try {
		dispatch(start());
		const response = await StnAPI.get(`/users/customer?active=true`, {
			headers: {
				'x-customer-id': customerID,
				'x-site-id': useSiteId(),
			},
		});

		dispatch(getStnEngineerUsers(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};
export const getStnEngineerExplicitly = customerID => async dispatch => {
	// export const setCustomerByID = customerID => async dispatch => {
	try {
		dispatch(start());
		const response = await StnAPI.get(`/users/customer?active=true`, {
			headers: {
				'x-customer-id': customerID,
				'x-site-id': useSiteId(),
			},
		});

		dispatch(getStnActiveEngineerUsers(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};

// Create Customer
export const createCustomer =
	(
		customerName,
		address,
		city,
		state,
		zip,
		phone,
		primaryContactName,
		primaryContactEmail,
		customerKey,
		forceCustomerKey,
		toggle,
		site_id,
		drive_id,
	) =>
	async dispatch => {
		const secondaryContactName = '';
		const secondaryContactEmail = '';
		try {
			const response = await API.post('/customers/', {
				customerName,
				address,
				city,
				state,
				zip,
				phone,
				primaryContactName,
				primaryContactEmail,
				secondaryContactName,
				secondaryContactEmail,
				customerKey,
				forceCustomerKey,
			});

			dispatch(setNewCustomer(response?.data));
			toggle();
			toast.success('Customer Created Successfully!');
			dispatch(syncSharepointMetadata(site_id, drive_id, true));
			dispatch(getAllCustomers());
			toast.success(
				'Your document repository is currently being provisioned, please check back in a few minutes',
			);
		} catch (err) {
			toast.error(err?.response?.data?.detail || 'Something went wrong');
			raiseErrorException(err, dispatch, setReducerError);
		}
	};

// Update Specific Customer
export const updateCustomerByID =
	(
		customerID,
		customerName,
		primaryContactName,
		primaryContactEmail,
		secondaryContactName,
		secondaryContactEmail,
		confluencePage,
		monitoringUrl,
		gpuoneLoginNode,
		setError,
		form,
		notes = '',
	) =>
	async dispatch => {
		try {
			toast.warning('Updating Customer...');
			const response = await API.put(`/customers/`, {
				customerID,
				customerName,
				primaryContactName,
				primaryContactEmail,
				secondaryContactName,
				secondaryContactEmail,
				confluencePage,
				monitoringUrl,
				gpuoneLoginNode,
				notes,
			});

			dispatch(setCurrentCustomer(response?.data));
			toast.success('Customer Updated Successfully!');
			dispatch(getCurrentCustomer());
			form.reset();
			dispatch(getAllCustomers());
		} catch (err) {
			setError({ settings: err.response?.data?.detail });
			raiseErrorException(err, dispatch, setReducerError);
		}
	};
export const updateCustomerInfo =
	(data, setShowInstructions, escalationPath) => async dispatch => {
		try {
			const response = await API.put(`/customers/`, data);

			dispatch(setCurrentCustomer(response?.data));
			toast.success('Customer Updated Successfully!');
			dispatch(getCurrentCustomer());
			if (setShowInstructions) {
				setShowInstructions(false);
			}
			if (escalationPath) {
				dispatch(getEscalationPath(false));
			}
		} catch (err) {
			console.log('err', err);
			raiseErrorException(err, dispatch, setReducerError);
		}
	};

export const updateCustomerOnBoardingProcess =
	(customerID, data) => async dispatch => {
		try {
			toast.warning('Updating Customer...');
			const response = await API.put(`/customers/`, {
				customerID,
				...data,
			});
			const getToken = JSON.parse(getLocalStorageData('token'));
			let token = getToken?.currentUser?.token;
			let refresh = getToken?.currentUser?.refresh;
			dispatch(UpdateCredsAction(token, refresh));
			dispatch(setCurrentCustomerOnboardingData(response?.data));
			toast.success('Customer Updated Successfully!');
		} catch (err) {
			raiseErrorException(err, dispatch, setReducerError);
		}
	};

// Update Specific Customer -> Scim
export const updateScimCustomerByID = (customerID, data) => async dispatch => {
	try {
		toast.warning('Updating Scim...');
		const response = await API.put(`/customers/`, data);
		dispatch(setCurrentCustomer(response?.data));
		dispatch(getUserProvisioning(customerID));
		toast.success('Scim Updated Successfully!');
		dispatch(getCurrentCustomer());
		dispatch(getAllCustomers());
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError);
	}
};

// Update Specific Customer's SSO Setting (enabled/ disabled)
export const updateCustomerSsoSetting =
	(customerID, primaryContactEmail, secondaryContactEmail, enabledSso) =>
	async dispatch => {
		try {
			const response = await API.put(`/customers/`, {
				customerID,
				primaryContactEmail,
				secondaryContactEmail,
				enabledSso,
			});

			dispatch(setCurrentCustomer(response?.data));
			toast.success(`SSO ${enabledSso ? 'enabled' : 'disabled'} successfully`);
			dispatch(getCurrentCustomer());
		} catch (err) {
			raiseErrorException(err, dispatch, setReducerError);
		}
	};

// Archive specific Customer
export const archiveCustomerByID = () => async dispatch => {
	try {
		await API.delete(`/customers/archive`);
		toast.success('Customer archived successfully');
		dispatch(getAllCustomers());
		dispatch(getArchivedCustomers());
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError);
	}
};

// Unarchive specific Customer
export const unarchiveCustomerByID = () => async dispatch => {
	try {
		await API.post(`/customers/unarchive`);
		toast.success('Customer unarchived successfully');
		dispatch(getAllCustomers());
		dispatch(getArchivedCustomers());
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError);
	}
};

// Delete specific Customer
export const deleteCustomerByID = () => async dispatch => {
	try {
		const response = await API.delete(`/customers/`);
		dispatch(setDeletedCustomer(response?.data));
		toast.success('Customer deleted successfully');
		dispatch(getAllCustomers());
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError);
	}
};

// get Customer's SSO Configurations and update the redux store
export const getCustomerSsoConfig = () => async dispatch => {
	dispatch(start());
	try {
		const response = await API.get(`/customers/sso_config/`);

		dispatch(setSsoConfigSettings(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};

// Save Customer's SSO COnfigurations
export const saveCustomerSsoConfig =
	(customerID, payload, setError) => async dispatch => {
		dispatch(start());
		try {
			const response = await API.post(`/customers/sso_config`, {
				...payload,
			});

			dispatch(setSsoConfigSettings(response?.data));
			toast.success('SSO Configuration Saved Successfully.');
			dispatch(getCurrentCustomer());
			dispatch(getCustomerSsoConfig(customerID));
		} catch (err) {
			setError({ settings: err.response?.data?.detail });
			raiseErrorException(err, dispatch, setReducerError);
		}
	};

// Update Customer's SSO COnfigurations
export const updateCustomerSsoConfig =
	(customerID, payload, setError) => async dispatch => {
		dispatch(start());
		try {
			const response = await API.put(`/customers/sso_config`, {
				...payload,
			});

			dispatch(setSsoConfigSettings(response?.data));
			toast.success('SSO Configuration Updated Successfully.');
		} catch (err) {
			setError({ settings: err.response?.data?.detail });
			raiseErrorException(err, dispatch, setReducerError);
		}
	};

// get Virtual Machine Quota by customer ID (review done)
export const getVirtualMachineQuota = customerID => async dispatch => {
	try {
		dispatch(setVmQuota(null));
		dispatch(start());
		const response = await API.get(`/customers/quota`);

		dispatch(setVmQuota(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};

// update Virtual Machine Quota by customer ID
export const updateVirtualMachineQuota =
	(customerID, quota, setEditModal) => async dispatch => {
		try {
			dispatch(start());
			const response = await API.put(`/customers/quota`, quota);

			dispatch(setUpdateVmQuota(response?.data));
			toast.success('Virtual Machine Quota Updated Successfully!');
			setEditModal(false);
			dispatch(getVirtualMachineQuota(customerID));
		} catch (err) {
			raiseErrorException(err, dispatch, setReducerError);
		}
	};

// add Virtual Machine Quota by customer ID
export const addVirtualMachineQuota =
	(customerID, quota, setModal) => async dispatch => {
		try {
			dispatch(start());
			const response = await API.post(`/customers/quota`, quota);
			dispatch(setAddVmQuota(response?.data));
			toast.success('Virtual Machine Quota Added Successfully!');
			setModal(false);
			dispatch(getVirtualMachineQuota(customerID));
		} catch (err) {
			raiseErrorException(err, dispatch, setReducerError);
		}
	};

// Get Remaining Quota by customer ID
export const getRemainingQuota = customerID => async dispatch => {
	try {
		dispatch(start());
		const response = await API.get(`/customersquota/remaining`);
		dispatch(setRemainingQuota(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};

// Get CMDB Services by customer ID
export const getCmdbServices = setResetForm => async dispatch => {
	try {
		dispatch(start());
		const response = await API.get(`/customers/cmdb`);
		dispatch(setCmdbServices(response?.data));
		if (setResetForm) {
			if (typeof setResetForm === 'function') {
				setResetForm(false);
			}
		}
	} catch (err) {
		if (err?.response?.status) {
			if (setResetForm) {
				if (typeof setResetForm === 'function') {
					setResetForm(true);
				}
			}
			dispatch(setCmdbServices({}));
		}
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};
export const getCmdbServicesForSiteFiltration =
	(customerID, currentSite) => async dispatch => {
		try {
			console.log(customerID);
			dispatch(start());

			const response = await StnAPI.get(`/customers/cmdb`, {
				headers: {
					'x-customer-id': customerID,
					'x-site-id': currentSite || useSiteId(),
				},
			});
			dispatch(setCmdbServices(response?.data));
		} catch (err) {
			dispatch(setCmdbServices({}));
			raiseErrorException(err, dispatch, setReducerError, 'get');
		}
	};
// Get CMDB Services by customer ID
export const getAlertsService =
	(customerID, setResetForm) => async dispatch => {
		try {
			dispatch(start());
			const response = await API.get(`/customers/cmdb`);
			dispatch(setAlertService(response?.data));
			setResetForm(false);
		} catch (err) {
			if (setResetForm) {
				setResetForm(true);
			}
			raiseErrorException(err, dispatch, setReducerError, 'get');
		}
	};

// update CMDB Services by customer ID
export const updateCmdbServices = (customerID, services) => async dispatch => {
	try {
		dispatch(start());
		const Api_URL = services?.siteID ? StnAPI : API;
		const response = await Api_URL.put(`/customers/cmdb`, services, {
			headers: {
				'x-customer-id': services?.customerID,
				'x-site-id': services?.siteID,
			},
		});
		dispatch(setUpdateCmdbServices(response?.data));
		toast.success('CMDB Services Updated Successfully!');
		dispatch(getCmdbServices());
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError);
	}
};
// update Alert Services by customer ID
export const updateAlertServices =
	(customerID, managedVM, selfManagedVM) => async dispatch => {
		try {
			dispatch(start());
			const response = await API.put(`/customers/cmdb`, {
				managedVM,
				selfManagedVM,
			});
			dispatch(setUpdateAlertServices(response?.data));
			toast.success('Alert Updated Successfully!');
			dispatch(getAlertsService(customerID));
		} catch (err) {
			raiseErrorException(err, dispatch, setReducerError);
		}
	};

/// add cmdb services by customer id
export const addCmdbServices = (customerID, cmdb) => async dispatch => {
	try {
		dispatch(start());
		const response = await API.post(`/customers/cmdb`, {
			cmdb,
		});
		dispatch(setAddCmdbServices(response?.data));
		toast.success('CMDB Services Added Successfully!');
		dispatch(getCmdbServices());
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError);
	}
};

// Toggle the Modal that adds a customer
export const toggleCustomerModal = () => async dispatch =>
	dispatch(setToggleModal());

// Toggle the Modal that adds a customer
export const toggleAddEmailRecipientModal = () => async dispatch =>
	dispatch(setToggleEmailRecipientsModal());

// Toggle the Modal that updates SAML Settings for a Company
export const toggleSAMLSettingsModal = () => async dispatch =>
	dispatch(setToggleSAMLSettingsModal());
